export class ItemUPC {
  itemManagerUpcId!: number;
  itemManagerId!: number;
  upcCode!: string;
  [key: string]: any;
  constructor(itemUPC?: ItemUPC) {
    if (itemUPC) {
      this.itemManagerUpcId = itemUPC.itemManagerUpcId || 0;
      this.itemManagerId = itemUPC.itemManagerId || 0;
      this.upcCode = itemUPC.upcCode;
    }
  }
}
